import React, { useEffect, useState } from "react";
import HeaderImg from "../components/HeaderImg";
import {
  Input,
  Label,
  Textarea,
} from "../components/styledComponent/formInputs";
import { toast } from "react-toastify";
import { sendMessage } from "../api/usersApi";
import Loading from "../components/Loading";
import ContactUs from "../components/ContactUs";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact">
      <HeaderImg title="Contact Us" />

      <ContactUs contactPage={true} />
      {/* <div className="contact__mainCon"></div> */}
      <div
        style={{
          width: "100%",
          height: 500,
          overflow: "hidden",
        }}
      >
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.518530320519!2d7.4198565999999975!3d9.1075482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e756183e2e967%3A0x8f9dda66e9d925e7!2sChaol%20Carington%20LTD!5e0!3m2!1sen!2sng!4v1771684749990!5m2!1sen!2sng"
          width="100%"
          height={500}
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
